import { render, staticRenderFns } from "./ShoppingCartConnectRoom.vue?vue&type=template&id=04341c1d&scoped=true"
import script from "./ShoppingCartConnectRoom.vue?vue&type=script&lang=js"
export * from "./ShoppingCartConnectRoom.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartConnectRoom.vue?vue&type=style&index=0&id=04341c1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04341c1d",
  null
  
)

export default component.exports